import { render } from "./LeiConsideracaoListagem.vue?vue&type=template&id=50e3bc51&ts=true"
import script from "./LeiConsideracaoListagem.vue?vue&type=script&lang=ts"
export * from "./LeiConsideracaoListagem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__